(function () {
    'use strict';
    // Function to handle video playback
    function handleVideoPlayback() {
        const videos = document.getElementsByClassName('video');
        for (let i = 0; i < videos.length; i++) {
            const video = videos.item(i).getElementsByTagName('video')[0];
            const button = videos.item(i).getElementsByClassName('playpause')[0];
            button
                .addEventListener('click', function (e) {
                    if (button.classList.contains('paused')) {
                        video.play();
                        button.classList.remove('paused');
                    } else {
                        video.pause();
                        button.classList.add('paused');
                    }
                })
        }
    }
    // Initialize the video playback handler
    document.addEventListener('DOMContentLoaded', handleVideoPlayback);
})();
